import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import langM from './lang'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import { history } from 'src/core/router'
import { jumpToUser } from '../../../helper/webviewFun'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: langM.en,
    language:'en',
    isLoading: true,
    reqUrl:'/web/UserExtendRecordList',
    mapArr:[],
    throttling:false,
    inCbCf:5,
    hadValue:false,
  }

  async componentWillMount() {
    //设置语言 start
    let { language, inCbCf } = this.props.location.query
    setDocumentTitle('Goins Transer record')
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
      inCbCf:inCbCf
    })
    console.log('language', language)

    // end
    let uid = await setUidToken(this.props.location.query)
  }

  async onHandleRecord(reqUrl) {
    this.setState({
      isLoading: true,
    })
    // 代理金币记录列表
    let res = await http.post(reqUrl, { scroll: '0,20' })
    if (res.code !=0 ) return
    let mapArr = [];
    let hadValue = false
    res.res.list.forEach(element => {
      let index = mapArr.findIndex(item=> item.date == element.date)
      if (index>-1) {
        mapArr[index].list.push(element)
      }else{
        mapArr.push({date:element.date,list:[element]})
      }
    })
    
    this.setState({
      isLoading: false,
      mapArr,
      scroll:res.res.scroll,
      hasMore:res.res.hasMore,
      hadValue,
    })
  }
  
  addRankingList = async ()=>{
    await this.setState({throttling:true})
    let { mapArr, scroll, throttling, reqUrl }  = this.state
    let res =await http.post(reqUrl, { scroll })
    if (res.code !== 0) return
    let { list, scroll:newScroll, hasMore } = res.res
    list.forEach(element=>{
      let index = mapArr.findIndex(item=> item.date == element.date)
      if (index>-1) {
        mapArr[index].list.push(element)
      }else{
        mapArr.push({date:element.date,list:[element]})
      }
    })
    this.setState({
      mapArr,
      hasMore,
      scroll:newScroll,
      throttling:false,
    })
  }

  handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    let { hasMore, throttling } = this.state
    if (scrollTop + clientHeight + 50 < scrollHeight) return
    if (hasMore && !throttling) return this.addRankingList()
  }
  async componentDidMount() {
      await this.onHandleRecord('/web/UserExtendRecordList')
  }
  render() {
    let { lang,  mapArr, language, inCbCf } = this.state
    return (
      <div className={`newGoldRecold ${isRtl(language)?'arlang':''} `} onScroll={e=>this.handleScroll(e)}>
        <div className='ruby-agent-nav'>
          <div style={{height:'0.88rem',width:'6rem'}}></div>
        <div className='close-web-view'>
          <img className='close-img-icon' style={{ transform: `rotate(${isRtl(language) ? '180' : '0'}deg)` }} onClick={() => history.go(-1)} src='/img/app/ruby-agent/close-icon.png' />
          <div className='name-text'>{lang.coin_transfer}</div>
          <img className='close-img-icon'  style={{opacity:'0'}} src='/img/app/ruby-agent/recolde-detail.png' />
        </div>
        </div>
        <div style={{height:'1.76rem',width:'7.5rem'}}></div>
        <div className='tiew-tiitle'>
        <div className='rirt-lise'></div>
        <div className='list-root'>
        {mapArr.length>0 &&
          mapArr.map((item, index) => (
            <div className="list-item" key={item.date}>
             <div className='item-title'>{item.date}</div>
              {item.list.map((item,index)=>(item.type == 0 && <div key={index}  className='item-item'>
                 <div className='left'>
                    <img src={item.avatarurl} className='to-atv' onClick={()=>jumpToUser(item.recuid)}></img>
                    <div className='to-name-id'>
                      <div className='name'>{item.nickname}</div>
                      <div className='id-num'>ID: {item.duid}</div>
                    </div>
                 </div>
                 <div className='right'>
                   <div className='right-icon-num'>
                     <img className='gold-icon' src='/img/app/ruby-agent/small-gold-icon.png'></img>
                     <div className='num'>{`${item.type==0?"-":"+"}${item.gold}`}</div>
                   </div>
                   <div className='date-info'>{item.dateStamp}</div>
                 </div>
              </div>))}
            </div>
          ))}
        </div>
        {mapArr.length ==0 && (
          <div className="empty">
            <img className="emp-img" src="/img/app/ruby-agent/empty_bg.png"></img>
            <div className="emp-text">{lang.empText}</div>
          </div>
        )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/newGoldRecold/index.js